module.exports = __webpack_public_path__ + "img/touzi.b9292cd6.png";